<div class="nav-item dropdown p-2">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header nocollapse">
        Ranking Sort Question
      </div>
      <div [hidden]="folderId == -1">
        <div class="bg-info p-1 mb-3">
          <div class="row">
            <div class="col-md-10">
              <span class="text-white pt-2" style="font-size:18px; display:inline-block"><b>Folder Name : </b>{{ folderName }}</span>
            </div>
            <div class="col-md-2 py-1">
              <button type="button" class="btn btn-primary btn-action" (click)="BackToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-arrow-left"></i> Back to Section</button>
              <button type="button" class="btn btn-primary btn-action mb-0" (click)="BackUrl()"><i class="fa fa-home"></i> Home</button>
            </div>
          </div>
        </div>
      </div>
      <form [formGroup]="rankingsortForm" class="col-md-12">
        <div class="card mb-2">
          <div class="card-header btn-primary" (click)="showTitlePanel = !showTitlePanel" style="cursor:pointer;">
            <b>Question Title</b>
            <span class="float-end"><i class="fa" [ngClass]="{'fa-chevron-down': showTitlePanel, 'fa-chevron-right': !showTitlePanel}"></i></span>
          </div>
          <div class="collapse" [ngClass]="{'show': showTitlePanel}">

            <div class="card-body">
              <div class="col-md-12">
                <div class="nav-item dropdown p-2">
                  <div>
                    <small class="form-text text-muted invalid-control-message" *ngIf="!sliderForm.valid && sliderForm.touched">
                      Please Enter Required Fields.
                    </small>
                    <div class="row">
                      <div class="col-md-2">
                        <label data-required class="form-control-label" for="description">Title</label>
                      </div>
                      <div class="col-md-10">
                        <textarea class="form-control" style="width:100%" rows="10" id="description" name="description" formControlName="description" placeholder="Type Question" #description> </textarea>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <label class="form-control-label col-md-2" for="questionCategoryId"> Category</label>
                      <div class="col-md-3">
                        <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId" class="form-control">
                          <option value="" selected>--Select--</option>
                          <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId" [selected]="questionCategoryId==item?.questionCategoryId">
                            {{item.questionCategoryName}}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-auto">
                        <button type="button" class="btn btn-primary btn-action"
                                (click)="openCategoryModal()">
                          <i class="fa fa-plus"></i> Create Category
                        </button>
                      </div>
                      <label class="form-control-label col-md-auto" for="shortName">Short Name</label>
                      <div class="col-md-3">
                        <input class="form-control" maxlength="30" type="text" id="shortName" name="shortName" formControlName="shortName" placeholder="Short Name" />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mb-2">
          <div class="card-header btn-primary" (click)="showSchemaPanel = !showSchemaPanel" style="cursor:pointer;">
            <b>Options</b>
            <span class="float-end"><i class="fa" [ngClass]="{'fa-chevron-down': showSchemaPanel, 'fa-chevron-right': !showSchemaPanel}"></i></span>
          </div>
          <div class="collapse" [ngClass]="{'show': showSchemaPanel}">
            <div class="card-body">
              <form [formGroup]="rankingsortForm" class="col-md-12">
                <div class="nav-item dropdown p-2">

                  <form [formGroup]="optionsForm" #f="ngForm">
                    <div class="row mb-3">
                      <label data-required class="col-md-2 form-control-label" for="optionName">Option Name<sup class="text-danger">&ast;</sup></label>
                      <div class="col-md-2">
                        <input class="form-control" type="text" id="optionName" name="optionName" formControlName="optionName" placeholder="Option Name" />
                      </div>
                      <label class="col-md-2 form-control-label" for="optionShortName">Short Name</label>
                      <div class="col-md-2"><input class="form-control" type="text" id="optionShortName" name="optionShortName" formControlName="optionShortName" placeholder="Short Name" /></div>
                      <div class="col-md-2">
                        <button type="button" class="btn btn-primary btn-action" [disabled]="!rankingsortForm.valid" (click)="AddUpdateOptionDetail($event)"><i class="fa fa-map-o"></i> Add/Update</button>
                      </div>
                    </div>
                    <div class="form-group">
                      <isg-grid
                        [rowData]="optionList"
                        [columnDefs]="colDefsOptions"
                        [config]="optionGridConfig"
                        (rowSelected)="onRowSelected($event)"
                        (apiReady)="onOptionGridApiReady($event)">
                      </isg-grid>
                    </div>
                  </form>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!--Footer including Save button-->
        <div class="card-footer">
          <div class="col-md-12">
            <div class="text-center">
              <button type="submit" class="btn btn-primary btn-action" [disabled]="!rankingsortForm.valid" (click)="saveRankingsortQs()"><i class="fa fa-save"></i> Save</button>
              <button type="submit" class="btn btn-secondary btn-action" (click)="BackUrl()" [hidden]="redirectedSectionId!=null || redirectedSurveyId!=null"><i class="fa fa-times"></i> Cancel</button>
              <button type="button" class="btn btn-secondary btn-action" (click)="BackToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-times"></i> Cancel</button>

            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!--Modals-->
  <ng-template #CreateCategoryModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Create Category</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="ResetQuesCategoryForm(); modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="quesCategoryForm" #f="ngForm">
        <div class="row align-items-center">
          <label data-required class="form-control-label col-md-4" for="quesCategoryName">Category</label>
          <div class="col-md-8">
            <input class="form-control" type="text" id="quesCategoryName" name="quesCategoryName" formControlName="quesCategoryName" placeholder="Category" />
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary btn-modal" (click)="ResetQuesCategoryForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
      <button type="button" class="btn btn-primary btn-modal" [disabled]="!quesCategoryForm.valid" (click)="AddQuesCategory(); modal.close()"><i class="fa fa-save"></i> Save</button>
    </div>
  </ng-template>
</div>
<ng-template #deleteConfirmation let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Delete Option Confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="form-control-label">
      Are you sure you want to delete the selected option?
    </div>
    <br />
    <div class="modal-footer">
      <button type="button" (click)="DeleteOption(); modal.close()" class="btn btn-danger btn-modal"><i class="fa fa-trash"></i> Delete</button>
      <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    </div>
  </div>
</ng-template>
